// src/components/layout/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import ThemeSwitcher from '../ui/ThemeSwitcher';
import DesignSwitcher from '../ui/DesignSwitcher';

function Header() {
  const { t } = useTranslation();
  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo">
          {t('appName')}
        </Link>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <nav
            className="header__nav"
            aria-label={t('nav.primaryNavigation', 'Primary navigation')}
          >
            <Link className="header__nav-link" to="/calculator">
              {t('nav.calculator')}
            </Link>
            {/* Nowe linki */}
            <Link className="header__nav-link" to="/theory">
              {t('nav.theory')}
            </Link>
            <Link className="header__nav-link" to="/glossary">
              {t('nav.glossary')}
            </Link>
            <Link className="header__nav-link" to="/method-guide">
              {t('nav.methodGuide')}
            </Link>
            <Link className="header__nav-link" to="/examples">
              {t('nav.examples')}
            </Link>
            <Link className="header__nav-link" to="/labs">
              {t('nav.labs')}
            </Link>
            <Link className="header__nav-link" to="/about">
              {t('nav.about')}
            </Link>
          </nav>
          <LanguageSwitcher />
          <ThemeSwitcher />
          <DesignSwitcher />
        </div>
      </div>
    </header>
  );
}
export default Header;
